import React from "react";
import { AllDataAccount } from "../../../generated/types";
import {
  DataTable,
  DataTableSkeletonRows,
  DataTableSort,
} from "../../common/DataTable";
import { UserColumnKey, UserRow, useUserColumns } from "./UserRow";

type UsersTableContentProps = {
  users: AllDataAccount[];
  isLoading: boolean;
  favorites: string[];
  selectedId: string;
  onSelectUser: (user: AllDataAccount) => void;
  onToggleFavorite: (
    accountId: string | number
  ) => (e: React.MouseEvent) => void;
  sort?: DataTableSort<UserColumnKey>;
  onSort: (key: UserColumnKey) => void;
  scrollKey: string;
};

export const UsersTableContent = ({
  users,
  isLoading,
  favorites,
  selectedId,
  onSelectUser,
  onToggleFavorite,
  sort,
  onSort,
  scrollKey,
}: UsersTableContentProps) => {
  const columns = useUserColumns();

  return (
    <DataTable
      columns={columns}
      scrollKey={scrollKey}
      sort={sort}
      onSort={onSort}
    >
      {isLoading ? (
        <DataTableSkeletonRows columns={columns} />
      ) : (
        users.map((user) => {
          const userId = String(user.account.id);
          return (
            <UserRow
              key={userId}
              user={user}
              isFavorite={favorites.includes(userId)}
              onToggleFavorite={onToggleFavorite(userId)}
              onClick={() => onSelectUser(user)}
              selected={userId === selectedId}
            />
          );
        })
      )}
    </DataTable>
  );
};
